import WifiPanelResultsDisplay, {
  WifiPanelResultsDisplayProps,
} from '../components/compositions/WifiPanelResultsDisplay';
import ChannelDropdown from './ChannelDropdown';
import ChannelUsageSlider from './ChannelUsageSlider';
import ChannelWidthPicker from './ChannelWidthPicker';
import MCS from './MCS';
import MCSChart from './MCSChart';
import AFCCheckbox from './AFCCheckbox';
import MLOCheckbox from './MLOCheckbox';
import RadioPicker from './RadioPicker';
import SignalStatusBar from './SignalStatusBar';
import SpeedStatusBar from './SpeedStatusBar';

const WifiPanelResultsDisplayContainer = (props: Partial<WifiPanelResultsDisplayProps>) => {
  return (
    <WifiPanelResultsDisplay
      ChannelDropdown={ChannelDropdown}
      ChannelUsageSlider={ChannelUsageSlider}
      ChannelWidthPicker={ChannelWidthPicker}
      MCS={MCS}
      MCSChart={MCSChart}
      AFCCheckbox={AFCCheckbox}
      MLOCheckbox={MLOCheckbox}
      RadioPicker={RadioPicker}
      SignalStatusBar={SignalStatusBar}
      SpeedStatusBar={SpeedStatusBar}
      {...props}
    />
  );
};

export default WifiPanelResultsDisplayContainer;
